export default __webpack_public_path__ + "static/media/about.70309690.svg";